import { useState, useEffect, useCallback } from 'react';

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue === null ? defaultValue : JSON.parse(storedValue);
  });

  useEffect(() => {
    const listener = (ev) => {
      if (ev.storageArea === localStorage && ev.key === key) {
        setValue(ev.newValue === null ? defaultValue : JSON.parse(ev.newValue));
      }
    };
    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
  }, [key]);

  const setValueInLocalStorage = useCallback(
    (newValue) => {
      setValue((currentValue) => {
        const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
        if (currentValue !== result) {
          localStorage.setItem(key, JSON.stringify(result));
        }
        return result;
      });
    },
    [key]
  );

  return [value, setValueInLocalStorage];
}
